<template>
  <div class="app-prod">
    <div class="prod-header">
      <h2>{{ $t('prod.name') }}</h2>
    </div>
    <div class="prod-body">
       <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick" >
        <el-tab-pane :label="$t('prod.attr_1')" name="0">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(o, index) in prodData_1" :key="index" style="margin-top: 15px;">
              <el-card :body-style="{ padding: '0px' }" >
                <img @click="handleDetail(o)" :src="imgBaseURL + o.prodImg" class="image">
                <div style="padding: 14px;">
                  <span @click="handleDetail(o)">{{ o.prodTitle }}</span>
                  <!-- <div class="bottom clearfix">
                    <a >{{ o.prodDesc }}</a>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('prod.attr_2')" name="1">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(o, index) in prodData_2" :key="index" style="margin-top: 15px;">
              <el-card :body-style="{ padding: '0px' }" >
                <img @click="handleDetail(o)" :src="imgBaseURL + o.prodImg" class="image">
                <div style="padding: 14px;">
                  <span @click="handleDetail(o)">{{ o.prodTitle }}</span>
                  <!-- <div class="bottom clearfix">
                    <a >{{ o.prodDesc }}</a>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('prod.attr_3')" name="2">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(o, index) in prodData_3" :key="index" style="margin-top: 15px;">
              <el-card :body-style="{ padding: '0px' }" >
                <img @click="handleDetail(o)" :src="imgBaseURL + o.prodImg" class="image">
                <div style="padding: 14px;">
                  <span @click="handleDetail(o)">{{ o.prodTitle }}</span>
                  <!-- <div class="bottom clearfix">
                    <a >{{ o.prodDesc }}</a>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('prod.attr_4')" name="3">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(o, index) in prodData_4" :key="index" style="margin-top: 15px;">
              <el-card :body-style="{ padding: '0px' }" @click="handleDetail(o)">
                <img @click="handleDetail(o)" :src="imgBaseURL + o.prodImg" class="image">
                <div style="padding: 14px;">
                  <span @click="handleDetail(o)">{{ o.prodTitle }}</span>
                  <!-- <div class="bottom clearfix">
                    <a >{{ o.prodDesc }}</a>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('prod.attr_5')" name="4">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(o, index) in prodData_5" :key="index" style="margin-top: 15px;">
              <el-card :body-style="{ padding: '0px' }" @click="handleDetail(o)">
                <img @click="handleDetail(o)" :src="imgBaseURL + o.prodImg" class="image">
                <div style="padding: 14px;">
                  <span @click="handleDetail(o)">{{ o.prodTitle }}</span>
                  <!-- <div class="bottom clearfix">
                    <a >{{ o.prodDesc }}</a>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '0',
      prodData_1: [],
      prodData_2: [],
      prodData_3: [],
      prodData_4: [],
      prodData_5: [],
      prodData_6: [],
      imgBaseURL: 'http://www.jinhui-ncm.cn/img/'

    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    handleClick(tab, event) {
      debugger
      console.log(tab, event);
    },
    handleSearch() {
      this.prodData_1 = [],
      this.prodData_2 = [],
      this.prodData_3 =[],
      this.prodData_4 =[],
      this.prodData_5 =[],
      this.prodData_6 =[],
      this.$axios.get('/api/products/findList').then(res => {
        if (res.data.code = 200) {
          res.data.forEach(i => {
            if(i.prodType === 0) {
              this.prodData_1.push(i)
            } else if(i.prodType === 1) {
              this.prodData_2.push(i)
            }else if(i.prodType === 2) {
              this.prodData_3.push(i)
            }else if(i.prodType === 3) {
              this.prodData_4.push(i)
            }else if(i.prodType === 4) {
              this.prodData_5.push(i)
            }
          });
        }
      });
    },
    handleDetail(el) {
      this.$router.push(`/prodDetail/${el.prodId}`);
    }
  }
}
</script>

<style scoped>
.app-prod {
  padding: 70px 130px;
  min-height: 600px;
  background-color: #fff;
}
.app-prod .prod-header {
  text-align: center;
  color: dodgerblue;
}
.app-prod .prod-body {
  margin-top: 40px;
}

.image {
    width: 100%;
    height: 245px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>



// WEBPACK FOOTER //
// src/views/Products.vue